import type { InputItems } from '~/types/entry-members-form';

export const createEntryMember = async (
  jobId: number,
  input: InputItems,
): Promise<string> => {
  try {
    const response = await fetch('/api/nextjs_api/entry-member', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ jobId, input }),
    });

    const data = await response.json();
    return data.redirect_url;
  } catch (error) {
    console.error('Error in client createEntryMember:', error);
    throw error;
  }
};
